import { formatToBRL } from 'brazilian-values'

import { businessUnit } from '@/utils/themes/theme'

export const getCurrencyName = () => {
  if (businessUnit(globalThis?.location?.hostname) === 'GBPT') {
    return 'Euro (€)'
  }
  return 'Real (R$)'
}

export const formatCurrency = (value) => {
  const result = formatToBRL(value)
  if (businessUnit(globalThis?.location?.hostname) === 'GBPT') {
    return result.replace('R$', '€')
  }
  return result
}
